import React from 'react';
import { Form } from 'react-bootstrap';

interface ValidatedFormControlProps extends React.ComponentProps<typeof Form.Control> {
    showErrors?: boolean;
    label?: string;
    options?: { value: string | number; label: string }[]; // For select dropdowns
}

const FormControl: React.FC<ValidatedFormControlProps> = ({
                                                              showErrors = false,
                                                              value,
                                                              required,
                                                              label,
                                                              options,
                                                              as,
                                                              ...props
                                                          }) => {
    const isEmpty =
        value === undefined ||
        value === null ||
        (typeof value === 'string' && value.trim() === '');

    const showInvalid = showErrors && isEmpty && required;

    const controlAs = as ?? (options ? 'select' : 'input'); // auto-select 'select' if options provided

    return (
        <>
            {label && (
                <Form.Label>
                    {label}
                    {required && <sup className="text-danger">*</sup>}
                </Form.Label>
            )}
            <Form.Control
                {...props}
                as={controlAs}
                value={value}
                isInvalid={showInvalid}
            >
                {options &&
                    options.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
            </Form.Control>
            {showInvalid && (
                <div className="invalid-feedback">This field is required.</div>
            )}
        </>
    );
};

export default FormControl;
